import React from "react";
import { createRoot } from 'react-dom/client';
import { BrowserRouter,Route,Routes } from "react-router-dom";
import OraxHome from "./OraxHome";
import OraxLogin from "./OraxLogin";
import OraxAdmin from "./OraxAdmin";
import OraxAboutUs from "./OraxAboutUs";
import OraxContact from "./OraxContact";
import OraxNews from "./OraxNews";
import OraxCookiesPolicy from "./OraxCookiesPolicy";

/* Constantes globales*/
const winwidth = window.innerWidth;
const windheight = window.innerHeight;
const session = sessionStorage.getItem('token');
const modo_desarrollo = false;
const ip = modo_desarrollo ? "192.168.1.44":"";
const port = modo_desarrollo ? '4000':"";
const protocolo = modo_desarrollo ? 'http://':"/api";
const DEBUG = true; // Si es true para visualizar los console logs
//Leer el modo desde la url de la aplicación, e.g.: localhost:3000/?modo=oraxulux o localhost:3000/?modo=frater
const params = new URLSearchParams(window.location.search);
const modo = params.get('modo') || "frater"; // por ejemplo: "admin o frater"

//const ip = "10.144.149.163"; //Para local debian en Orion5 o Docker en Debian en Orion5
//const ip = "10.144.97.107"; //Para local Fedora en Orion5 o Docker en Fedora
//const ip = "localhost"; //Para Docker en equipo local

console.log('Modo leido de la URL o aplicado por defecto:', modo);
console.log("El modo es",modo_desarrollo?" desarrollo":"producción");

const root = createRoot(document.getElementById('root'));

root.render(
    <BrowserRouter>
        <Routes>
            {(<Route path='/' element={<OraxHome ip={ip} port={port} modo={modo} protocolo={protocolo} winwidth={winwidth}
                                                         winheight={windheight} debug={DEBUG}/>}/>)}
            {(<Route path='/sobreNosotros' element={<OraxAboutUs ip={ip} port={port} modo={modo} protocolo={protocolo} winwidth={winwidth}
                                                                             winheight={windheight} debug={DEBUG} />}/>)}
            {(<Route path='/contacto' element={<OraxContact ip={ip} port={port} modo={modo} protocolo={protocolo} winwidth={winwidth}
                                                                 winheight={windheight} debug={DEBUG} />}/>)}
            {(<Route path='/noticias' element={<OraxNews ip={ip} port={port} modo={modo} protocolo={protocolo} winwidth={winwidth}
                                                            winheight={windheight} modo_desarrollo = {modo_desarrollo} debug={DEBUG} />}  />)}
            {(<Route path='/cookiesPolicy' element={<OraxCookiesPolicy ip={ip} port={port} modo={modo} protocolo={protocolo} winwidth={winwidth}
                                                         winheight={windheight} debug={DEBUG} />} />)}
            {(!session && <Route path='/login' element={<OraxLogin ip={ip} modo={modo} port={port} protocolo={protocolo} winwidth={winwidth}
                                                         winheight={windheight} modo_desarrollo = {modo_desarrollo} debug={DEBUG} />}/>)}
            {(session && <Route path='/admin' element={<OraxAdmin ip={ip} port={port} modo={modo} protocolo={protocolo} winwidth={winwidth}
                                                         winheight={windheight} modo_desarrollo = {modo_desarrollo} debug={DEBUG} />} />)}
        </Routes>
    </BrowserRouter>
);
